// @ts-nocheck TODO: fix types for the entire file

import styled from '@emotion/styled';
import { Button } from 'components/Buttons';
import { CustomIcon } from 'components/CustomIcon';
import MBDialog from 'components/Elements/MBDialog';
import MBSelect from 'components/Forms/MBSelect/MBSelect';
import MBTextField from 'components/Forms/MBTextField/MBTextField';
import { Typography } from 'components/Typography';
import { pxToEm } from 'theme';
import unitsToRem from 'theme/unitsToRem';
import { Status } from '../../../typings/enums';

export const Header = styled(Typography)`
  font-weight: 600;
  font-size: ${pxToEm(28)};
  line-height: 36px;
  color: ${({ theme }) => theme.palette.grey[800]};
`;

export const SubTitle = styled(Typography)`
  padding-bottom: ${pxToEm(24)};
`;

export const Paragraph = styled(Typography)``;

export const DropZone = styled.div<{
  droppedImages: boolean;
  isPalette?: boolean;
  isLoading?: boolean;
}>`
  font-size: ${({ isPalette }) => (isPalette ? unitsToRem(1.5) : pxToEm(16))};
  flex: 1;
  width: 100%;
  height: 100%;
  min-height: ${({ isLoading }) => (isLoading ? pxToEm(312) : pxToEm(210))};
  display: flex;
  flex-direction: column;
  justify-content: ${({ droppedImages }) =>
    droppedImages ? 'flex-start' : 'center'};
  align-items: center;
  background-color: ${({ theme }) => theme.palette.secondary?.main};
  border-radius: 12px;
  &:hover {
    background-color: ${({ theme }) => theme.palette.grey['50']};
  }

  @keyframes rotating {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  .spinnerIcon {
    animation: rotating 1s linear infinite;
  }
`;

export const Input = styled.input`
  display: none;
`;

export const UploadButton = styled(Button)<{ isDragActive: boolean }>`
  padding: 0.75em 1.5em;

  &.MuiButton-containedSecondary {
    background-color: ${({ theme }) => theme.palette.common.white};
    &:hover,
    &:focus,
    &:active {
      background: ${({ theme }) => theme.palette.primary.main};
      color: ${({ theme }) => theme.palette.common.white};
    }
  }
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: ${pxToEm(8)};
`;

export const FileName = styled(Typography)`
  max-width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 24px;
`;

export const SelectWrapper = styled.div`
  margin-right: auto;
`;

export const Select = styled(MBSelect)`
  font-size: inherit;

  & .MuiSelect-select {
    &:focus {
      background-color: inherit;
    }
  }
`;

export const FileIcon = styled.div`
  margin-left: auto;
`;

export const FileImageWrapper = styled.div<{ status?: Status }>`
  width: 100%;
  aspect-ratio: 1/1;
  object-fit: cover;

  @keyframes blink-animation {
    0% {
      opacity: 0.5;
    }
    50% {
      opacity: 0.8;
    }
    100% {
      opacity: 0.5;
    }
  }
  @-webkit-keyframes blink-animation {
    0% {
      opacity: 0.5;
    }
    50% {
      opacity: 0.8;
    }
    100% {
      opacity: 0.5;
    }
  }

  ${({ status }) => {
    switch (status) {
      case Status.ERROR:
        return 'opacity: 0.5;';
      case Status.LOADING:
        return 'animation: blink-animation 2s linear infinite;';
      default:
        return 'opacity: 1;';
    }
  }};
`;

export const FileItem = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${pxToEm(16)};
`;

export const Dialog = styled(MBDialog)`
  & .MuiDialogTitle-root {
    font-weight: 600;
    & p {
      margin-left: 0;
      font-weight: 600;
    }
  }
  & .MuiDialogContent-root {
    margin-bottom: 0;
    overflow-y: unset;
  }
  & .MuiDialogActions-root {
    margin-top: 1em;
  }
  #close_modal_button {
    top: 1em;
    right: 1em;
  }
  .MuiPaper-root {
    padding: 32px !important;
  }
`;

export const FieldWrapper = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  background: ${({ theme }) => theme.palette.secondary?.main};
  border-radius: 24px;
  padding: 6px;
`;
export const TextField = styled(MBTextField)`
  .MuiInputBase-input {
    height: 36px;
    padding-right: 10px;
    padding-left: 20px;
  }
  .MuiInputBase-root {
    background: none !important;
    &:hover,
    &:focus,
    &:active {
      background: none !important;
    }
    &:after {
      display: none;
    }
  }
`;

export const SubmitButton = styled(Button)`
  padding: 0 16px;
  height: 36px;
  width: 85px;
  flex-shrink: 0;

  &.MuiButton-containedSecondary {
    background-color: ${({ theme }) => theme.palette.common.white};
    &:hover,
    &:focus,
    &:active {
      background: ${({ theme }) => theme.palette.primary.main};
      color: ${({ theme }) => theme.palette.common.white};
    }
  }
`;

export const ErrorMessages = styled.ul``;

export const Spinner = styled(CustomIcon)`
  @keyframes rotating {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
    animation: rotating 2s linear infinite;
  }
`;
